import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { TokenName } from '../config/app.config';

@Injectable()

export class CustomerGuard implements CanActivate {

  constructor(private router: Router) {}

  public canActivate() {
    const item = JSON.parse(localStorage.getItem(TokenName));
    if (item && item.role) {
      return item.role.is_customer;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/guards/customer.guard.ts